import type { Clip, Range } from '../types'

/**
 * Tính các khoảng được GIỮ LẠI: bắt đầu từ [0, duration] rồi trừ đi toàn bộ
 * các khoảng bị xóa (removed).
 */
export function computeKeptRanges(duration: number, removed: Range[]): Range[] {
  if (duration <= 0) return []
  const rm = removed
    .filter((r) => r.end > r.start)
    .map((r) => ({ start: Math.max(0, r.start), end: Math.min(duration, r.end) }))
    .sort((a, b) => a.start - b.start)

  // gộp các khoảng bị xóa chồng lấn
  const merged: Range[] = []
  for (const r of rm) {
    const last = merged[merged.length - 1]
    if (last && r.start <= last.end + 0.001) last.end = Math.max(last.end, r.end)
    else merged.push({ ...r })
  }

  const kept: Range[] = []
  let cursor = 0
  for (const r of merged) {
    if (r.start > cursor) kept.push({ start: cursor, end: r.start })
    cursor = Math.max(cursor, r.end)
  }
  if (cursor < duration) kept.push({ start: cursor, end: duration })

  return kept.filter((r) => r.end - r.start > 0.001)
}

/** Tập khoảng bị xóa của một clip: từ đã xóa + các cut thủ công/tự động. */
export function clipRemoved(clip: Clip): Range[] {
  const fromWords = clip.words
    .filter((w) => w.removed)
    .map((w) => ({ start: w.start, end: w.end }))
  return [...fromWords, ...clip.cuts]
}

/** Các khoảng được giữ lại của một clip. */
export function clipKept(clip: Clip): Range[] {
  return computeKeptRanges(clip.duration, clipRemoved(clip))
}

/** Tổng thời lượng của một tập khoảng. */
export function totalDuration(ranges: Range[]): number {
  return ranges.reduce((acc, r) => acc + (r.end - r.start), 0)
}
